module.exports = __webpack_public_path__ + "static/media/cel_oceanview_bedroom-790x444.4051e850.jpg";